<template>
  <div class="container mx-auto h-full md:flex justify-center items-center m-8">
    <div class="md:w-1/2">
      <h1 class="font-hairline mb-6 text-center">Neu Registrieren</h1>
      <div v-if="error" @click="close" class="mb-4 bg-red-lightest border border-red-light text-red-dark px-4 py-3 rounded relative" role="alert">
        <span class="block sm:inline">{{error}}</span>
      </div>
      <div class="p-3">
        <button @click="signInWithGoogle" tag="button" class="bg-teal-dark hover:bg-teal text-white py-2 px-2 rounded">Google</button>
        <button @click="signInWithFacebook" tag="button" class="bg-teal-dark hover:bg-teal text-white py-2 px-2 rounded">Facebook</button>
        <button @click="signInWithPhone" tag="button" class="bg-teal-dark hover:bg-teal text-white py-2 px-2 rounded">Handy</button>
      </div>
      <div class="p-8">
        <form v-on:submit.prevent="signUp">
          <div class="mb-4">
            <label class="font-bold text-grey-darker block mb-2">Vor- und Nachname</label>
            <input v-model="name" type="text" class="block appearance-none w-full bg-white border border-grey-light hover:border-grey px-2 py-2 rounded shadow" placeholder="Vor- und Nachname">
          </div>
          <div class="mb-4">
            <label class="font-bold text-grey-darker block mb-2">Email-Adresse</label>
            <input v-model="email" type="text" class="block appearance-none w-full bg-white border border-grey-light hover:border-grey px-2 py-2 rounded shadow" placeholder="Email">
          </div>
          <div class="mb-4">
            <label class="font-bold text-grey-darker block mb-2">Passwort</label>
            <input v-model="password" type="password" class="block appearance-none w-full bg-white border border-grey-light hover:border-grey px-2 py-2 rounded shadow" placeholder="Passwort">
          </div>
          <div class="mb-4">
            <label class="font-bold text-grey-darker block mb-2">Telefonnummer</label>
            <input v-model="phone" type="text" class="block appearance-none w-full bg-white border border-grey-light hover:border-grey px-2 py-2 rounded shadow" placeholder="Telefonnummer">
          </div>
          <div class="text-center">
            <button type="submit" class="bg-teal-dark hover:bg-teal text-white py-2 px-2 rounded">Registrieren</button>
          </div>
        </form>
      </div>
      <div class="text-center">
        <p class="text-grey-dark text-sm">Bereits einen Account?
          <router-link to="/login" class="no-underline text-blue font-bold">Anmelden</router-link>.</p>
      </div>
    </div>
  </div>
</template>

<script>
  import firebase from 'firebase'
  export default {
    name: 'signUp',
    data: function () {
      return {
        error: '',
        email: '',
        password: '',
        name: '',
        phone: ''
      }
    },
    methods: {
      close: function () {
        this.error = false
      },
      signUp: function () {
        firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then(
          (user) => {
            firebase.database().ref('users/' + user.uid).set({
              name: this.name,
              email: user.email,
              phone: this.phone,
              photo: user.photoURL,
              admin: false,
              agent: false,
              date: new Date()
            })
            this.$router.push({
              name: 'services'
            })
          },
          (err) => {
            this.error = err.message
          }
        )
      },
      signInWithGoogle: function () {
        let provider = this.$root.$data.firebase.googleProvider
        this.$root.$data.firebase.app.auth().signInWithPopup(provider).then(
          (result) => {
            const user = result.user
            // console.log(user)
            firebase.database().ref('users/' + user.uid).set({
              name: user.displayName,
              email: user.email,
              phone: user.phoneNumber,
              photo: user.photoURL,
              admin: false,
              agent: false,
              date: new Date()
            })
            this.$router.push({
              name: 'services'
            })
          },
          (err) => {
            this.error = err.message
          }
        )
      },
      signInWithFacebook: function () {
        let provider = this.$root.$data.firebase.facebookProvider
        this.$root.$data.firebase.app.auth().signInWithPopup(provider).then(
          (result) => {
            const user = result.user
            // console.log(user)
            firebase.database().ref('users/' + user.uid).set({
              name: user.displayName,
              email: user.email,
              phone: user.phoneNumber,
              photo: user.photoURL,
              admin: false,
              agent: false,
              date: new Date()
            })
            this.$router.push({
              name: 'services'
            })
          },
          (err) => {
            this.error = err.message
          }
        )
      },
      signInWithPhone: function () {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SignUp.vue